import React, { useEffect, useState, createContext, useContext } from 'react';
export type Theme = 'light' | 'dark' | 'navy';
interface ThemeContextType {
  theme: Theme;
  setTheme: (theme: Theme) => void;
}
const ThemeContext = createContext<ThemeContextType | undefined>(undefined);
export function ThemeProvider({
  children
}: {
  children: ReactNode;
}) {
  const [theme, setThemeState] = useState<Theme>(() => {
    // Load theme from localStorage or default to 'light'
    const savedTheme = localStorage.getItem('yeppy-theme') as Theme;
    return savedTheme || 'light';
  });
  useEffect(() => {
    // Save theme to localStorage
    localStorage.setItem('yeppy-theme', theme);
    // Apply theme to document root
    document.documentElement.setAttribute('data-theme', theme);
    // Update body background color based on theme
    if (theme === 'light') {
      document.body.style.backgroundColor = '#F1F1E9';
    } else if (theme === 'dark') {
      document.body.style.backgroundColor = '#1D2A36';
    } else if (theme === 'navy') {
      document.body.style.backgroundColor = '#0F1B2E';
    }
  }, [theme]);
  const setTheme = (newTheme: Theme) => {
    setThemeState(newTheme);
  };
  return <ThemeContext.Provider value={{
    theme,
    setTheme
  }} data-id="element-456">
      {children}
    </ThemeContext.Provider>;
}
export function useTheme() {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}